import { Helpers } from '../../helpers';
import { IMajorMilestoneType } from '../../interfaces/imajor-milestone-type';
import { MajorMilestone } from '../major-milestone';

export class MajorMilestoneTypeBase {
  MajorMilestoneTypeId: number;
  Name: string | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  MajorMilestones_MajorMilestoneType?: Array<MajorMilestone> | null;

  constructor(item?: IMajorMilestoneType) {
    if (item) {

      this.MajorMilestoneTypeId = item.MajorMilestoneTypeId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.MajorMilestones_MajorMilestoneType = Helpers.createClassArray(MajorMilestone, item.MajorMilestones_MajorMilestoneType);
    }
  }
}